import { render, staticRenderFns } from "./clientDetails.vue?vue&type=template&id=d7900d48&scoped=true&"
import script from "./clientDetails.vue?vue&type=script&lang=js&"
export * from "./clientDetails.vue?vue&type=script&lang=js&"
import style0 from "./clientDetails.vue?vue&type=style&index=0&id=d7900d48&prod&scoped=true&lang=scss&"
import style1 from "./clientDetails.vue?vue&type=style&index=1&id=d7900d48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7900d48",
  null
  
)

export default component.exports